import { format } from 'date-fns';

export const defaultMaxDate = new Date(new Date().getFullYear() + 15, 11, 31);
export const defaultMinDate = new Date(new Date().getFullYear() - 10, 0, 1);
export const DATE_FORMAT = 'M/d/yyyy';
export const DATE_TIME_FORMAT = 'M/d/yyy h:mmaaa';

export const getDateAsUTC = (dateString) => {
  let dateObject = new Date(dateString);

  let utcDate = new Date(
    dateObject.getUTCFullYear(),
    dateObject.getUTCMonth(),
    dateObject.getUTCDate(),
    dateObject.getUTCHours(),
    dateObject.getUTCMinutes(),
  );

  return utcDate.toString();
};

export const formatDate = (dateString, includeTime = false) => {
  if (!dateString) {
    return '';
  } else {
    let localDate = new Date(dateString);

    return format(localDate, includeTime ? DATE_TIME_FORMAT : DATE_FORMAT);
  }
};

export const formatDateTime = (dateString) => {
  return formatDate(dateString, true);
};

const today = new Date();
export const OPEN_FISCAL_YEARS =
  today.getMonth() < 5
    ? [today.getFullYear()]
    : today.getMonth() <= 6
    ? [today.getFullYear(), today.getFullYear() + 1]
    : [today.getFullYear() + 1];
export const CURRENT_FISCAL_YEAR =
  today.getMonth() >= 6 ? today.getFullYear() + 1 : today.getFullYear();

const getFiscalYearRange = (yearOffset = 0) => {
  let startDate;
  let endDate;
  if (today.getMonth() >= 6) {
    startDate = new Date(today.getFullYear() + yearOffset, 6, 1);
    endDate = new Date(today.getFullYear() + 1 + yearOffset, 5, 30);
  } else {
    startDate = new Date(today.getFullYear() - 1 + yearOffset, 6, 1);
    endDate = new Date(today.getFullYear() + yearOffset, 5, 30);
  }
  return [startDate, endDate];
};

export const getDateRangeForYear = (fiscalYear) => {
  let startDate;
  let endDate;
  if (Array.isArray(fiscalYear)) {
    startDate = new Date(fiscalYear[0] - 1, 6, 1);
    endDate = new Date(fiscalYear[fiscalYear.length - 1], 5, 30);
  } else {
    startDate = new Date(fiscalYear - 1, 6, 1);
    endDate = new Date(fiscalYear, 5, 30);
  }

  return [startDate, endDate];
};

export const getFiscalYearsFromRange = (dateRange) => {
  let fyForStart =
    dateRange[0].getMonth() >= 6
      ? dateRange[0].getFullYear() + 1
      : dateRange[0].getFullYear();
  let fyForEnd =
    dateRange[1].getMonth() >= 6
      ? dateRange[1].getFullYear() + 1
      : dateRange[1].getFullYear();

  return Array.from(
    { length: fyForEnd - fyForStart + 1 },
    (_, i) => fyForStart + i,
  );
};
export const getFiscalYearList = (numberOfYears) => {
  return Array.from({ length: numberOfYears }, (_, i) => {
    let year = CURRENT_FISCAL_YEAR - i;
    return {
      id: `FY_${year}`,
      dateRange: getDateRangeForYear(year),
      label: `Fiscal Year ${year}`,
      year: `${year}`,
    };
  });
};

export const areRangesEqual = (dr1, dr2) => {
  if (dr1?.length !== 2 || dr2?.length !== 2) {
    return false;
  }
  return (
    formatDate(dr1[0]) === formatDate(dr2[0]) &&
    formatDate(dr1[1]) === formatDate(dr2[1])
  );
};
